import {
  Banknote,
  Coffee,
  Dumbbell,
  GraduationCap,
  Home,
  Hotel,
  Landmark,
  Shirt,
  ShoppingBag,
  Stethoscope,
  Store,
  Utensils,
} from "lucide-react";
import type React from "react";

/**
 * Maps Mapbox `maki` icon identifiers to Lucide React icon components.
 * Used to render contextual icons in search results and popups.
 */
export const iconMap: Record<string, React.ReactNode> = {
  café: <Coffee className="h-5 w-5" />,
  cafe: <Coffee className="h-5 w-5" />,
  coffee: <Coffee className="h-5 w-5" />,
  restaurant: <Utensils className="h-5 w-5" />,
  food: <Utensils className="h-5 w-5" />,
  hotel: <Hotel className="h-5 w-5" />,
  lodging: <Hotel className="h-5 w-5" />,
  gym: <Dumbbell className="h-5 w-5" />,
  bank: <Banknote className="h-5 w-5" />,
  shopping: <ShoppingBag className="h-5 w-5" />,
  store: <Store className="h-5 w-5" />,
  government: <Landmark className="h-5 w-5" />,
  school: <GraduationCap className="h-5 w-5" />,
  hospital: <Stethoscope className="h-5 w-5" />,
  clothing: <Shirt className="h-5 w-5" />,
  home: <Home className="h-5 w-5" />,
};
